import { now } from '@calendly/datetime';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseIcon, DollarSign } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { colorIconMeetingIntelligence } from '@calendly/ui/theme';
import classNames from 'classnames';
import { useEffect, useState, forwardRef } from 'react';
import { TRACKING_EVENT_NAMES, useTrack } from 'hooks/analytics_events';
import { UpgradeLink } from './shared';
const paywallBannerContentWrapperCss = "ptb2doh";
const PaywallBannerContentWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(paywallBannerContentWrapperCss, props.className)} />;
});
const paywallBannerMainWrapperCss = "p191xcmm";
const PaywallBannerMainWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(paywallBannerMainWrapperCss, props.className)} />;
});
const trackEvent = (track, name, properties) => {
  track({
    name,
    entities: ['attribution', 'organization', 'user'],
    properties
  });
};
const upgradeLinkOptions = (featureKey, onClick) => ({
  UpgradeLink: ({
    children
  }) => <UpgradeLink featureKey={featureKey} onClick={onClick}>
      {children}
    </UpgradeLink>
});
export const PaywallBanner = ({
  featureKey
}) => {
  const track = useTrack();
  const [closed, setClosed] = useState(false);
  const onClick = () => trackEvent(track, TRACKING_EVENT_NAMES.CTA_CLICKED, {
    cta_destination: 'ai_paywall',
    cta_key: 'meetings',
    cta_text: 'upgrade',
    action: 'interaction'
  });
  const handleClose = () => {
    const today = now().toISO();
    setClosed(true);
    window.localStorage.setItem('mi_meetings_page_paywall_dismissed_on', today);
  };
  useEffect(() => {
    trackEvent(track, TRACKING_EVENT_NAMES.CTA_SHOWN, {
      cta_destination: 'ai_paywall',
      cta_key: 'meetings',
      cta_text: 'upgrade'
    });
  }, [track]);
  if (closed) return null;
  return <PaywallBannerMainWrapper>
      <PaywallBannerContentWrapper>
        <DollarSign color={colorIconMeetingIntelligence} />
        <BodyText>
          {HtmlParser(I18n.t('publisher.billing.meeting_intelligence.meetings_upgrade_paywall_notice'), upgradeLinkOptions(featureKey, onClick))}
        </BodyText>
      </PaywallBannerContentWrapper>

      <div>
        <IconButton title={I18n.t('publisher.action.close')} onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </div>
    </PaywallBannerMainWrapper>;
};

require("./paywall_banner.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./paywall_banner.js");